"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EntityPartialUpdateBuilder = void 0;
var tslib_1 = require("tslib");
var PartialUpdateBuilder_1 = require("./PartialUpdateBuilder");
var message = tslib_1.__importStar(require("../message"));
var intersection_1 = require("../intersection");
var connector_1 = require("../connector");
var EntityPartialUpdateBuilder = /** @class */ (function (_super) {
    tslib_1.__extends(EntityPartialUpdateBuilder, _super);
    /**
     * @param entity
     * @param operations
     */
    function EntityPartialUpdateBuilder(entity, operations) {
        var _this = _super.call(this, operations) || this;
        _this.entity = entity;
        return _this;
    }
    /**
     * @inheritDoc
     */
    EntityPartialUpdateBuilder.prototype.execute = function () {
        var _this = this;
        var state = intersection_1.Metadata.get(this.entity);
        var body = JSON.stringify(this);
        var msg = new message.UpdatePartially(state.bucket, state.key, body);
        return state.withLock(function () { return (state.db.send(msg).then(function (response) {
            // Update the entity’s values
            state.type.fromJsonValue(state, response.entity, _this.entity, { persisting: true });
            return _this.entity;
        }, function (e) {
            if (e.status === connector_1.StatusCode.OBJECT_NOT_FOUND) {
                state.db.removeReference(_this.entity);
            }
            throw e;
        })); });
    };
    return EntityPartialUpdateBuilder;
}(PartialUpdateBuilder_1.PartialUpdateBuilder));
exports.EntityPartialUpdateBuilder = EntityPartialUpdateBuilder;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiRW50aXR5UGFydGlhbFVwZGF0ZUJ1aWxkZXIuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJFbnRpdHlQYXJ0aWFsVXBkYXRlQnVpbGRlci50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7O0FBQUEsK0RBQThEO0FBRTlELDBEQUFzQztBQUV0QyxnREFBMkM7QUFDM0MsMENBQTBDO0FBRTFDO0lBQWtFLHNEQUF1QjtJQUN2Rjs7O09BR0c7SUFDSCxvQ0FBNEIsTUFBUyxFQUFFLFVBQW1CO1FBQTFELFlBQ0Usa0JBQU0sVUFBVSxDQUFDLFNBQ2xCO1FBRjJCLFlBQU0sR0FBTixNQUFNLENBQUc7O0lBRXJDLENBQUM7SUFFRDs7T0FFRztJQUNILDRDQUFPLEdBQVA7UUFBQSxpQkFpQkM7UUFoQkMsSUFBTSxLQUFLLEdBQUcsdUJBQVEsQ0FBQyxHQUFHLENBQUMsSUFBSSxDQUFDLE1BQU0sQ0FBQyxDQUFDO1FBQ3hDLElBQU0sSUFBSSxHQUFHLElBQUksQ0FBQyxTQUFTLENBQUMsSUFBSSxDQUFDLENBQUM7UUFDbEMsSUFBTSxHQUFHLEdBQUcsSUFBSSxPQUFPLENBQUMsZUFBZSxDQUFDLEtBQUssQ0FBQyxNQUFNLEVBQUUsS0FBSyxDQUFDLEdBQUksRUFBRSxJQUFJLENBQUMsQ0FBQztRQUV4RSxPQUFPLEtBQUssQ0FBQyxRQUFRLENBQUMsY0FBTSxPQUFBLENBQzFCLEtBQUssQ0FBQyxFQUFFLENBQUMsSUFBSSxDQUFDLEdBQUcsQ0FBQyxDQUFDLElBQUksQ0FBQyxVQUFDLFFBQVE7WUFDL0IsNkJBQTZCO1lBQzdCLEtBQUssQ0FBQyxJQUFJLENBQUMsYUFBYSxDQUFDLEtBQUssRUFBRSxRQUFRLENBQUMsTUFBTSxFQUFFLEtBQUksQ0FBQyxNQUFNLEVBQUUsRUFBRSxVQUFVLEVBQUUsSUFBSSxFQUFFLENBQUMsQ0FBQztZQUNwRixPQUFPLEtBQUksQ0FBQyxNQUFNLENBQUM7UUFDckIsQ0FBQyxFQUFFLFVBQUMsQ0FBQztZQUNILElBQUksQ0FBQyxDQUFDLE1BQU0sS0FBSyxzQkFBVSxDQUFDLGdCQUFnQixFQUFFO2dCQUM1QyxLQUFLLENBQUMsRUFBRSxDQUFDLGVBQWUsQ0FBQyxLQUFJLENBQUMsTUFBTSxDQUFDLENBQUM7YUFDdkM7WUFDRCxNQUFNLENBQUMsQ0FBQztRQUNWLENBQUMsQ0FBQyxDQUNILEVBWDJCLENBVzNCLENBQUMsQ0FBQztJQUNMLENBQUM7SUFDSCxpQ0FBQztBQUFELENBQUMsQUE5QkQsQ0FBa0UsMkNBQW9CLEdBOEJyRjtBQTlCWSxnRUFBMEIifQ==